import { filter, isEmpty, toLower } from "lodash";
const initialState = {
  //vendor
  vendorList: [],
  vendorDataList: [],
  poByVendorIdList:[],
    isFetchingVendor: false,
    isAddingVendor: false,
    isFetchingPoByVendorId:false,
};

const VendorReducer = (state = initialState, action) => {
  switch (action.type) {
    // get VENDOR
    case "REQUEST_VENDOR_GET_DATA":
      return { ...state, isFetchingVendor: true, };
  case "SUCCESS_VENDOR_GET_DATA":
      return {
          ...state,
          vendorDataList: action.payload.result,
          isFetchingVendor: false,
      };
  case "ERROR_VENDOR_GET_DATA":
      return { ...state,};
      //get po by vedor id
      case "REQUEST_GET_PO_BY_VENDOR_ID":
        return { ...state, isFetchingPoByVendorId: true, };
    case "SUCCESS_GET_PO_BY_VENDOR_ID":
        return {
            ...state,
            poByVendorIdList: action.payload,
            isFetchingPoByVendorId: false,
        };
    case "ERROR_GET_PO_BY_VENDOR_ID":
        return { ...state,isFetchingPoByVendorId:false};
      //add vendor
      case "REQUEST_ADD_VENDOR":
        return { ...state, isAddingVendor: true};
      case "SUCCESS_ADD_VENDOR":
        return {
          ...state,
          vendorList: action.payload,
          isAddingVendor: false,
        };
      case "ERROR_ADD_VENDOR":
        return { ...state, isAddingVendor: false};      default:
        return state;
    }
  };
  export default VendorReducer;